import isUUID from 'validator/lib/isUUID'
import isString from 'lodash.isstring'

/**
 * at this time, there are sporadic instances of Segment using the user's email
 * address as the userId field on Track calls. force reset the Segment ID if
 * that's the case.
 *
 * the reason why this happens is unknown. all Segment identify calls
 * are passed the Thrive User Id, which is a UUID. however, it appears that there
 * was some instance in the past where ajs_id in the document.cookie was indeed an
 * email address. again, what caused this is unknown. if a user never cleared
 * their cache, it will keep that email address value as the Segment id
 */
export const checkSegmentId = () => {
  const analytics = window.analytics
  const segmentUserId = analytics.user().id()
  // protect against calling the validator without a string — it will error out
  if (isString(segmentUserId) && !isUUID(segmentUserId)) {
    analytics.reset()
  }
}
